import React from 'react';
import { Table, Column, Chip } from '@v2/components';
import type { Pims } from '@v2/types';
import type { PimsTableProps } from './types';

const columns: Column<Pims>[] = [
  {
    key: 'name',
    header: 'Name',
    sortKey: 'name',
    render: row => <span>{row.name}</span>,
  },
  {
    key: 'supportsConnectivity',
    header: 'Supports Connectivity',
    render: row => (
      <Chip variant={row.supportsConnectivity ? 'primary' : 'neutral'} size="sm">
        {row.supportsConnectivity ? 'Yes' : 'No'}
      </Chip>
    ),
  },
];

const PimsTable: React.FC<PimsTableProps> = ({
  pims,
  loading,
  error,
  search,
  onSearchChange,
  sortConfig,
  onSortChange,
  selectedPimsId,
  onSelectPims,
}) => (
  <Table<Pims>
    columns={columns}
    data={pims}
    keyExtractor={p => p.id}
    loading={loading}
    error={error}
    emptyMessage="No PIMS found."
    onRowClick={onSelectPims}
    selectedKeys={selectedPimsId ? [selectedPimsId] : []}
    sortConfig={sortConfig}
    onSortChange={onSortChange}
    search={search}
    onSearchChange={onSearchChange}
    searchPlaceholder="Search PIMS by name..."
  />
);

export { PimsTable };
export default PimsTable;
